import { observable, action } from "mobx";
import * as mobx from 'mobx'
import Promise from 'bluebird';
import moment from 'moment'

const stripe = process.env.REACT_APP_STRIPE_ENVIROMENT
const app = process.env.REACT_APP_APP_ENVIROMENT

function comparer(otherArray){
  return function(current){
    return otherArray.filter(function(other){
      return other.leadID == current._id
    }).length == 0;
  }
}

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}



function makeLabel(value){
  if(value){
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
  }
  return ''
}


class CommonStore {
//customize app based settings
/* Settings */

  @observable appName = "Sonic Portal";
  @observable agent = {};
  @observable network = {};
  @observable customer = {};
  @observable campaign = {};
  @observable campaignRowsPerPage = 0;
  @observable supportCases = [];
  @observable supportCaseRowsPerPage = 0;
  //@observable savedSearch = 0;


/* Loading */
  @observable appLoaded = false;
  @observable appLoading = false;
  @observable loading = false;
  @observable stripeEnv = stripe;
  @observable appEnv = app;

  @observable signInError = '';

  /* Default or Load data */
  @observable leadTypes = [
    {"povertyLevel":'0', label: 'Less than 100% Poverty Level'},
    {"povertyLevel":'1', label: "100% to 200% > than the Poverty Level"},
    {"povertyLevel":'2', label: "200% to 300% > than the Poverty Level"},
    {"povertyLevel":'3', label: "300% to 400% > than the Poverty Level"},
    {"povertyLevel":'4', label: "400% and Greater > than the Poverty Level"},
    {"povertyLevel":'5', label: "five"},
    {"povertyLevel":'6', label: "six"},
    {"povertyLevel":'7', label: "seven"},
    {"povertyLevel":'8', label: "eight"},
    {"povertyLevel":'9', label: "nine"},
  ]


  @observable lastResultCodes = [
    {name: 'APPT', color: '#036daf'},
    {name: 'Contacted', color: '#0089ba'},
    {name: 'Follow Up', color: '#06aa8f'},
    {name: 'Incorrect Person', color: '#ad03a4'},
    {name: 'DNC', color: '#757575'},
    {name: 'DNQ', color: '#ad0505'},
    {name: 'Give Up', color: '#b75e00'},
    {name: 'NI/Covered', color: '#a9055a'},
    {name: 'No_Contact', color: '#c63f81'},
    {name: 'Retry___', color: '#cc9502'},
    {name: 'SOLD', color: '#00af1a'},
    {name: 'Spanish', color: '#a3690d'},
    {name: 'Transfer', color: '#6b6b6b'},
    {name: 'Non-Working Number', color: '#ad03a4'},
]

  @observable destinationAttributes = {
    standard: [
      {
          "mapTo": "Povert_Level",
          "field": "povertyLevel",
          "name": "Poverty Level",
          "description" : "This is description",
          "score": 10
      },
      {
          "mapTo": "Price",
          "field": "price",
          "recordType": "lead",
          "name": "Price",
          "description" : "This is description",
          "score": 11
      },
      {
        "mapTo": "Expectant_Mother",
        "field": "pregnant",
        "recordType": "vertical",
        "name": "Pregnant",
        "description" : "This is description",
        "score": 12
      },
      {
        "mapTo": "Conditions",
        "field": "condition",
        "recordType": "vertical",
        "name": "Condition",
        "description" : "This is description",
        "score": 13
      },
      {
        "mapTo": "First_Name",
        "field": "firstName",
        "recordType": "profile",
        "name": "First Name",
        "description" : "This is description",
        "score": 1
      },
      {
        "mapTo": "Last_Name",
        "field": "lastName",
        "recordType": "profile",
        "name": "Last Name",
        "description" : "This is description",
        "score": 2
      },
      {
        "mapTo": "State",
        "field": "region",
        "recordType": "profile",
        "name": "State",
        "description" : "This is description",
        "score": 3
      },
      {
        "mapTo": "Email",
        "field": "email",
        "recordType": "profile",
        "name": "Email",
        "description" : "This is description",
        "score": 5
      },
      {
        "mapTo": "Phone",
        "field": "phone",
        "recordType": "lead",
        "name": "Phone",
        "description" : "This is description",
        "score": 5
      },
      {
        "mapTo": "Zip_Code",
        "field": "postalCode",
        "recordType": "profile",
        "name": "Zip Code",
        "description" : "This is description",
        "score": 6
      },
      {
        "mapTo": "DOB",
        "field": "ageRange",
        "recordType": "profile",
        "name": "Age Range",
        "description" : "This is description",
        "score": 7
      },
      {
        "mapTo": "Income",
        "field": "income",
        "recordType": "profile",
        "name": "Income",
        "description" : "This is description",
        "score": 8
      },
      {
        "mapTo": "Household",
        "field": "household",
        "recordType": "profile",
        "name": "Household",
        "description" : "This is description",
        "score": 9
      },
      {
        "description": "This is description",
        "field": "campaign",
        "isSelected": true,
        "mapTo": "Keyword",
        "name": "Keyword",
        "recordType": "lead",
        "score": 14
      },
    ],
    topbrokercrm: [
        {
          "mapTo": "firstName",
          "field": "firstName",
          "recordType": "profile",
          "name": "First Name",
          "description" : "This is description",
          "score": 1
        },
        {
          "mapTo": "lastName",
          "field": "lastName",
          "recordType": "profile",
          "name": "Last Name",
          "description" : "This is description",
          "score": 2
        },
        {
          "mapTo": "state",
          "field": "region",
          "recordType": "profile",
          "name": "State",
          "description" : "This is description",
          "score": 3
        },
        {
          "mapTo": "email",
          "field": "email",
          "recordType": "profile",
          "name": "Email",
          "description" : "This is description",
          "score": 4
        },
        {
          "mapTo": "phone",
          "field": "phone",
          "recordType": "lead",
          "name": "Phone",
          "description" : "This is description",
          "score": 5
        },
        {
          "mapTo": "zip",
          "field": "postalCode",
          "recordType": "profile",
          "name": "Zip Code",
          "description" : "This is description",
          "score": 6
        },
      ],
    vanillasoft : [
        {
            "mapTo": "Povert_Level",
            "field": "povertyLevel",
            "name": "Poverty Level",
            "description" : "This is description",
            "score": 10
        },
        {
            "mapTo": "Price",
            "field": "price",
            "recordType": "lead",
            "name": "Price",
            "description" : "This is description",
            "score": 11
        },
        {
          "mapTo": "Expectant_Mother",
          "field": "pregnant",
          "recordType": "vertical",
          "name": "Pregnant",
          "description" : "This is description",
          "score": 12
        },
        {
          "mapTo": "Conditions",
          "field": "condition",
          "recordType": "vertical",
          "name": "Condition",
          "description" : "This is description",
          "score": 13
        },
        {
          "mapTo": "First_Name",
          "field": "firstName",
          "recordType": "profile",
          "name": "First Name",
          "description" : "This is description",
          "score": 1
        },
        {
          "mapTo": "Last_Name",
          "field": "lastName",
          "recordType": "profile",
          "name": "Last Name",
          "description" : "This is description",
          "score": 2
        },
        {
          "mapTo": "State",
          "field": "region",
          "recordType": "profile",
          "name": "State",
          "description" : "This is description",
          "score": 3
        },
        {
          "mapTo": "Email",
          "field": "email",
          "recordType": "profile",
          "name": "Email",
          "description" : "This is description",
          "score": 5
        },
        {
          "mapTo": "Phone",
          "field": "phone",
          "recordType": "lead",
          "name": "Phone",
          "description" : "This is description",
          "score": 5
        },
        {
          "mapTo": "Zip_Code",
          "field": "postalCode",
          "recordType": "profile",
          "name": "Zip Code",
          "description" : "This is description",
          "score": 6
        },
        {
          "mapTo": "DOB",
          "field": "ageRange",
          "recordType": "profile",
          "name": "Age Range",
          "description" : "This is description",
          "score": 7
        },
        {
          "mapTo": "Income",
          "field": "income",
          "recordType": "profile",
          "name": "Income",
          "description" : "This is description",
          "score": 8
        },
        {
          "mapTo": "Household",
          "field": "household",
          "recordType": "profile",
          "name": "Household",
          "description" : "This is description",
          "score": 9
        },
        {
          "description": "This is description",
          "field": "campaign",
          "isSelected": true,
          "mapTo": "Keyword",
          "name": "Keyword",
          "recordType": "lead",
          "score": 14
        }
      ]
  }
  
  /* Processing */
  @observable paymentProgress = {isProcessing: false}
  //@observable addAvailStatus = {isProcessing: false}



/* Data */
  @observable cards = []
  @observable campaign = []
  @observable leads = []
  @observable leadScrollID = null
  @observable leadsTotal = 0
  @observable campaigns = []
  @observable allDestinations = []

/* Show */
  @observable showHeader = true


/* Settings Actions */
  @action
  setAgent(agent) {
    const { network, ...rest }  = agent
    console.log(network)
    if(!('credit' in agent)){
      agent.credit = 0
      return
    }
    this.network = network;
    this.agent = rest;
  }


  @action
  setCustomer(customer) {
    const { data } = customer.sources
    this.customer = customer;
    this.cards = data
  }


  @action
  setDestinations(destinations) {
    this.allDestinations = destinations;
  }

  @action
  setDestination(destination) {
    const { status } = destination
    const dests = this.allDestinations.slice()
    console.log(destination)
    console.log(dests)

    const foundItem = dests.filter(dest => {
      return dest.destID === destination.destID
    })

    if(foundItem.length > 0){
        const items = dests.map(dest => {
            if (dest.destID === destination.destID){
                return {...dest, ...destination}
            }
            return dest
        })

        this.allDestinations = items
    }else{
      dests.push(destination)
      this.allDestinations = dests
    }

    if(status === 'active'){
    //  this.campaign.destinations.push(destination)
    }

  }

  @action
  clearCampaign = () => {
    this.campaign = {}
  }

  @action
  setCampaignRowsPerPage = (rows) => {
    this.campaignRowsPerPage = rows
  }

  @action
  setSupportCaseRowsPerPage = (rows) => {
    this.supportCaseRowsPerPage = rows
  }

/* Processing Actions */
  @action
  setPaymentProgress = (payload) => {
    this.paymentProgress = payload;
  }
/*
  @action
  setAddAvailStatus(payload) {
    this.addAvailStatus = payload;
  }
*/

/* Loading Actions */
  @action
  setAppLoaded(appLoaded) {
    this.appLoaded = appLoaded;
  }

  @action
  setSignInError(err) {
    this.signInError = err;
  }

  @action
  setAppLoading(loading) {
    this.appLoading = loading;
  }

  @action
  setLoading(loading) {
    this.loading = loading;
  }

  @action
  toggleShowHeader() {
    this.showHeader = !this.showHeader;
  }

  

/* Data Actions */
  @action
  updateItem(type, item, single) {
    console.log('update: ' +  type)
    console.log(item)
    if(single){
      this[single] = item
    }
    if (type in this){
        console.log('got1')
        const items = this[type].map(now => {
          console.log(now)
            if (now.id === item.id){
              console.log(now.id)
              console.log(item.id)
                return {...now, ...item}
            }
            return now
        })
      this[type] = items
    }
  }

@action
deleteCampaign(campaignID){
    const filteredCampaigns = this.campaigns.filter((item) => {
        return item.campaignID !== campaignID
    }).slice()

    this.campaigns = filteredCampaigns
    this.loading = false
}
  
@action
setCampaigns(data){
  console.log(data)
  console.log('setCampaigns')
 // this.campaigns = []
 // let newCampaigns = []
      function getRegions(filters){
        const { topLevel } = filters
        let regions = []
  
        const regionFilterFound = topLevel.filter((item) => {
          return item.field === 'region'
        })
      
       // console.log(regionFilterFound)
      
      
        if(regionFilterFound.length > 0){
          regions = [...regionFilterFound[0].include]
        }
      
        return regions
      }

     // console.log(data)


      return Promise.filter(data, item => {
            const { campaignStatus } = item
            if(campaignStatus){
              return campaignStatus === 'active'
            }
            return true
      }).then((filteredData) => {
        console.log('filteredData')
        console.log(filteredData)
        return Promise.map(filteredData, campaign => {
                const { campaignID, filters, campaignCreated, balance, destinations, leadType, contactTypes, qualifiers } = campaign
              
           
                
                const regionsIncluded = getRegions(filters).join(', ')
                const formattedBalance = `$${(balance / 100).toLocaleString()}`
                const hasDestination = destinations.length > 0 ? 'Active Lead Destination' : 'No Active Lead Destination!'
                
                const formattedContactTypes = contactTypes.map((item) => {return makeLabel(item)}).join(', ')
                const formattedQualifiers = qualifiers.map((item) => {return makeLabel(item)}).join(', ')
                const formattedLeadType = makeLabel(leadType)
                return Promise.resolve({id: campaignID, ...campaign, formattedContactTypes, formattedQualifiers, formattedLeadType, regionsIncluded,  hasDestination, formattedBalance: formattedBalance, campaignCreated: moment(campaignCreated).format('MM/DD h:mm a')})
        })
    })
    .then((resultArray) => {
      console.log('resultArray')
      const filtered = resultArray.filter(item => {
          const { priceMapType } = item
          return priceMapType
      })
     // this.finalSetCampaigns(resultArray)
      this.finalSetCampaigns(filtered)
    })
}

@action
setSupportCases(data){
  console.log(data)
  console.log('setSupportCases')
  this.supportCases = data
}


@action
finalSetCampaigns = (campaigns) => {
  console.log('finalSetCampaigns')
  this.campaigns = campaigns
  this.loading = false
}

@action
setCampaign = (campaignResult) => {
  campaignResult.activeStep = 1
  this.addSelectedCampaign(campaignResult)

  /*return Promise.each(inclusions, inclusion => {
    const { field } = inclusion
    campaignResult[field] = inclusion
  })
  .then(() => {
    const campaign = {...data, ...campaignResult}
    this.addSelectedCampaign(campaign)
  })*/
}


@action
setLead = (data) => {
  const {leadID, lastResult, comment, keywordRating } = data

  let items = this.leads.slice()

  items = this.leads.map(item => {
      if(item.leadID === leadID){
        if(lastResult){
          item.actions = parseInt(item.actions) + 1
          item.lastResult = lastResult
        }
        if(comment){
          item.comment = comment 
        }
        if(keywordRating){
          item.keywordRating = keywordRating 
        }
      }
    return item
  })

  this.leads = items
 

}


@action
addSelectedCampaign(campaign){
  this.campaign = campaign
  this.loading = false

}


@action
saveLeadArray(leads){
  console.log(leads)

  

  const sortedLeads = leads.sort((a, b) => {return b.soldEpoch - a.soldEpoch})
  console.log(sortedLeads)
  this.leads = sortedLeads

 // points.sort((a, b) => {return b - a})

}

@action
setLeads(data){
  console.log('setLeads')
 console.log(data)

  const { _scroll_id } = data
  const { total: {value : total}, hits } = data.hits

  const resultArray = hits.map(item => {
    //console.log(item._source)
    const lead = {...item._source}
    const {leadID, agentEmail, agentPhone, emailOnly, campaignName, soldDate, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, campaign, crmContactID, destinationEmailID, lastResult, actions, comment, keywordRating } = lead
    const optional = {
      crmContactID: crmContactID ? crmContactID : '',
      destinationEmailID: destinationEmailID ? destinationEmailID : '',
      lastResult: lastResult ? lastResult : '',
      actions: actions ? actions : 0,
      comment: comment ? comment : '',
      keywordRating: keywordRating ? keywordRating : 0
    }
    console.log(leadType)
    return {id: leadID, agentEmail, agentPhone, emailOnly, soldEpoch: moment(soldDate).unix(), soldDate: moment(soldDate).format('MM/DD h:mm a'), leadID,  campaignName, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, keyword: campaign, ...optional }
  })

  console.log('setLeads total')
  console.log(total)

  console.log('resultArray.length')
  console.log(resultArray.length)

  if(resultArray.length >= total){
    this.leadScrollID = null
  }else{
    console.log('set leadScrollID ')
    this.leadScrollID = _scroll_id
  }
  this.saveLeadArray(resultArray)
  //this.leads = resultArray;
  this.leadsTotal = total
  this.loading = false
}




@action
addNowLeads(data){
  console.log('addNowLeads')
  console.log(data)

  const { hits } = data.hits
  //const currentLeads = this.leads.slice()

  const currentLeads= mobx.toJS(this.leads).slice()

  const difference = hits.filter(comparer(currentLeads));
   
  //const difference = hits.filter(x => !currentLeads.includes(x)).concat(currentLeads.filter(x => !hits.includes(x)));


  //const difference = currentLeads.filter(x => hits.includes(x)); 



  console.log(difference)
 
   const resultArray = difference.map(item => {
     //console.log(item._source)
     const lead = {...item._source}
     const {leadID, campaignName, soldDate, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, campaign, crmContactID, destinationEmailID, lastResult, actions, comment, keywordRating } = lead
     const optional = {
       crmContactID: crmContactID ? crmContactID : '',
       destinationEmailID: destinationEmailID ? destinationEmailID : '',
       lastResult: lastResult ? lastResult : '',
       actions: actions ? actions : 0,
       comment: comment ? comment : '',
       keywordRating: keywordRating ? keywordRating : 0
     }
     console.log(comment)
     return {id: leadID, soldDate: moment(soldDate).format('MM/DD h:mm a'), leadID,  campaignName, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, keyword: campaign, ...optional }
   })
   this.saveLeadArray([...resultArray, ...currentLeads])
   //this.leads = [...resultArray, ...currentLeads];
 
 }

@action
addScrollLeads(data){
 console.log(data)

 const { _scroll_id } = data
 const { total, hits } = data.hits

  const resultArray = hits.map(item => {
    //console.log(item._source)
    const lead = {...item._source}
    const {leadID, campaignName, soldDate, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, campaign, crmContactID, destinationEmailID, lastResult, actions, comment, keywordRating } = lead
    const optional = {
      crmContactID: crmContactID ? crmContactID : '',
      destinationEmailID: destinationEmailID ? destinationEmailID : '',
      lastResult: lastResult ? lastResult : '',
      actions: actions ? actions : 0,
      comment: comment ? comment : '',
      keywordRating: keywordRating ? keywordRating : 0
    }
    console.log(comment)
    return {id: leadID, soldDate: moment(soldDate).format('MM/DD h:mm a'), leadID,  campaignName, vertical, leadPrice, firstName, lastName, phone, email, region, postalCode, individual, pregnant, condition, leadType, qualifier, povertyLevel, ageRange, income, household, keyword: campaign, ...optional }
  })
  const currentLeads = this.leads.slice()
  //this.leads = [...resultArray, ...currentLeads];
  this.saveLeadArray([...currentLeads, ...resultArray])


  if(this.leads.length >= total){
    this.leadScrollID = null
  }else{
    this.leadScrollID = _scroll_id
  }

  this.loading = false
}
}


export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js